import { useSelector as reactReduxUseSelector } from 'react-redux'

function useSelector (selector) {
  return reactReduxUseSelector(selector)
}

export default useSelector
